































import { PropType } from 'vue';
import { mapActions } from 'vuex';

import mixins from '@/utils/mixins';
import authMixin from '@/mixins/auth';

import { setErrorFromAxiosError } from '@/utils/helpers';
import {
  IInventoryAdvancePayment,
  InventoryAdvancePaymentStatusEnum
} from '@/models';

import InventoryAdvancePaymentCancelButton from '../common/InventoryAdvancePaymentCancelButton.vue';
import InventoryAdvancePaymentStateTransitionCommentFormDialog from '../common/InventoryAdvancePaymentStateTransitionCommentFormDialog.vue';

const baseMixins = mixins(authMixin);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    commentDialog: InstanceType<
      typeof InventoryAdvancePaymentStateTransitionCommentFormDialog
    >;
  };
}
export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'InventoryAdvancePaymentApSpecialistAssignedStateCardActions',

    components: {
      InventoryAdvancePaymentCancelButton,
      InventoryAdvancePaymentStateTransitionCommentFormDialog
    },

    props: {
      inventoryAdvancePayment: {
        type: Object as PropType<IInventoryAdvancePayment>
      }
    },

    data() {
      return {
        isLoading: false
      };
    },

    methods: {
      ...mapActions({
        updateInventoryAdvancePaymentState:
          'inventoryAdvancePayment/updateInventoryAdvancePaymentState',
        fetchInventoryAdvancePaymentActivities:
          'inventoryAdvancePayment/fetchInventoryAdvancePaymentActivities'
      }),

      /**
       * @see api inventoryAdvancePayment/models/start_processing_invoice
       * can be called only from states:
       * - InventoryAdvancePaymentStatusEnum.RequestProcessed
       *
       * can go to state
       * - InventoryAdvancePaymentStatusEnum.Paid
       */
      async confirmPayment() {
        const {
          isConfirmed,
          comment
        } = await this.$refs.commentDialog.openCommentsDialog(
          InventoryAdvancePaymentStatusEnum.Paid
        );
        if (isConfirmed) {
          this.clearErrors();
          this.isLoading = true;
          this.updateInventoryAdvancePaymentState({
            id: this.inventoryAdvancePayment.id,
            state: InventoryAdvancePaymentStatusEnum.Paid,
            comment: comment
          })
            .then(() => {
              this.$emit('confirm-payment');
              this.fetchInventoryAdvancePaymentActivities(
                this.inventoryAdvancePayment.id
              );
            })
            .catch(error => {
              this.$emit('error', setErrorFromAxiosError(error));
            })
            .finally(() => {
              this.isLoading = false;
            });
        }
      },

      clearErrors() {
        this.$emit('clearErrors');
      }
    }
  });
